const STORAGE_KEY = "kim-tour-trip-planner";

const createId = (item) =>
  [item.category, item.title || item.name]
    .filter(Boolean)
    .join(":")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const getTripItems = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch (error) {
    return [];
  }
};

export const isTripItemSaved = (item) => {
  const id = item.id || createId(item);
  return getTripItems().some((savedItem) => savedItem.id === id);
};

export const saveTripItem = (item) => {
  const tripItems = getTripItems();
  const itemToSave = {
    ...item,
    id: item.id || createId(item),
    savedAt: new Date().toISOString(),
  };

  if (tripItems.some((savedItem) => savedItem.id === itemToSave.id)) {
    return { saved: false, item: itemToSave, reason: "exists" };
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify([itemToSave, ...tripItems]));
  return { saved: true, item: itemToSave };
};

export const removeTripItem = (id) => {
  const nextItems = getTripItems().filter((item) => item.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(nextItems));
  return nextItems;
};

export const clearTripItems = () => {
  localStorage.removeItem(STORAGE_KEY);
};
